//importing firebase
import {Auth} from "../firebase";
import {signOut} from "firebase/auth";

export function fb_signOut() {
    console.log("????");
    signOut(Auth)
        .then(response => {
            console.log(response);
        })
        .catch(error => {
            console.error("Failed to sign out. ", error.message);
        })
}